import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW6801Model } from './kymw6801.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { ConvDivComboBoxComponent } from '../../../commons/kymw02/combo-box/conv-div-combo-box/conv-div-combo-box.component';
import { ClassCodeComboBoxComponent } from '../../../commons/kymw02/combo-box/class-code-combo-box/class-code-combo-box.component';
import { LargeClassCodeComboBoxComponent } from '../../../commons/kymw02/combo-box/large-class-code-combo-box/large-class-code-combo-box.component';
import { MiddleClassCodeComboBoxComponent } from '../../../commons/kymw02/combo-box/middle-class-code-combo-box/middle-class-code-combo-box.component';
import { SmallClassCodeComboBoxComponent } from '../../../commons/kymw02/combo-box/small-class-code-combo-box/small-class-code-combo-box.component';
import { CodeComboBoxComponent } from '../../../commons/kymw02/combo-box/code-combo-box/code-combo-box.component';
import { MediumTypeComboBoxComponent } from '../../../commons/kymw02/combo-box/medium-type-combo-box/medium-type-combo-box.component';
import { PromotionCodeComboBoxComponent } from '../../../commons/kymw02/combo-box/promotion-code-combo-box/promotion-code-combo-box.component';
import { MarkCodeTextInputComponent } from '../../../commons/kymw02/text-input/mark-code-text-input/mark-code-text-input.component';
import { Kymw68FeatureCodeComboBoxComponent } from '../../../commons/kymw68/combo-box/feature-code-combo-box/feature-code-combo-box.component';
import { Kymw68TagComboBoxComponent } from '../../../commons/kymw68/combo-box/tag-combo-box/tag-combo-box.component';
import { KYMW6801InputModel } from './vo/kymw6801-input.model';
import { KYMW6801OutputModel } from './vo/kymw6801-output.model';
import { KYMW6800commonModel } from '../kymw6800/vo/kymw6800-common.model';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { GetCategoryConvInfoService } from './api-services/get-category-conv-info.service';
import { RegistCategoryConvInfoService } from './api-services/regist-category-conv-info.service';
import { UpdateCategoryConvInfoService } from './api-services/update-category-conv-info.service';
import { DeleteCategoryConvInfoService } from './api-services/delete-category-conv-info.service';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { RadioLabelComponent } from '../../../commons/kymw02/radio-label/radio-label.component';

/**
 * ECカテゴリ変換マスタ設定画面を管理するクラス
 *
 * @export KYMW6801Component
 * @class KYMW6801Component
 */
@Component({
  selector: 'app-kymw6801',
  templateUrl: 'kymw6801.component.html',
  styleUrls: ['kymw6801.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW6801Component extends PlessViewHelperSub implements OnInit, AfterViewInit {

  // 親画面からの連携値
  param: any;
  kymw6801Model: KYMW6801Model = new KYMW6801Model();
  // 受渡し情報
  public inputVo: KYMW6801InputModel = null;
  // 親画面への連携値
  outputVO: KYMW6801OutputModel = new KYMW6801OutputModel();
  setKYMW6801Parameter: Function;

  //@ViewChild('rdb_Category', { static: true }) rdb_Category: RadioLabelComponent;
  @ViewChild('rdb_PlanCategory', { static: true }) rdb_PlanCategory: RadioLabelComponent;
  //@ViewChild('rdb_StockCategory', { static: true }) rdb_StockCategory: RadioLabelComponent;
  @ViewChild('rdb_StockLimitFlg', { static: true }) rdb_StockLimitFlg: RadioLabelComponent;
  @ViewChild('cmb_ConvDiv', { static: true }) cmb_ConvDiv: ConvDivComboBoxComponent;
  @ViewChild('lbl_CategoryCode', { static: true }) lbl_CategoryCode: ElementRef;
  @ViewChild('cmb_ClassCode', { static: true }) cmb_ClassCode: ClassCodeComboBoxComponent;
  @ViewChild('cmb_LargeClassCode', { static: true }) cmb_LargeClassCode: LargeClassCodeComboBoxComponent;
  @ViewChild('cmb_MiddleClassCode', { static: true }) cmb_MiddleClassCode: MiddleClassCodeComboBoxComponent;
  @ViewChild('cmb_SmallClassCode', { static: true }) cmb_SmallClassCode: SmallClassCodeComboBoxComponent;
  @ViewChild('cmb_PricePattern', { static: true }) cmb_PricePattern: CodeComboBoxComponent;
  @ViewChild('cmb_MediumType', { static: true }) cmb_MediumType: MediumTypeComboBoxComponent;
  @ViewChild('cmb_FeatureCode', { static: true }) cmb_FeatureCode: Kymw68FeatureCodeComboBoxComponent;
  @ViewChild('cmb_ProDiv', { static: true }) cmb_ProDiv: PromotionCodeComboBoxComponent;
  @ViewChild('cmb_ProInfo', { static: true }) cmb_ProInfo: PromotionCodeComboBoxComponent;
  @ViewChild('txti_MarkCode1', { static: true }) txti_MarkCode1: MarkCodeTextInputComponent;
  @ViewChild('txti_MarkCode2', { static: true }) txti_MarkCode2: MarkCodeTextInputComponent;
  @ViewChild('txti_MarkCode3', { static: true }) txti_MarkCode3: MarkCodeTextInputComponent;
  @ViewChild('txti_PageNum', { static: true }) txti_PageNum: ElementRef;
  @ViewChild('txti_ExhibitionDiv', { static: true }) txti_ExhibitionDiv: ElementRef;
  @ViewChild('cmb_Tag1', { static: true }) cmb_Tag1: Kymw68TagComboBoxComponent;
  @ViewChild('cmb_Tag2', { static: true }) cmb_Tag2: Kymw68TagComboBoxComponent;
  @ViewChild('btn_Delete', { static: true }) btn_Delete: ElementRef;
  @ViewChild('btn_Close', { static: true }) btn_Close: ElementRef;

  /**
   * Creates an instance of KYMW6801Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {ElementRef} elementRef
   * @param {GetCategoryConvInfoService} getCategoryConvInfoService
   * @param {RegistCategoryConvInfoService} registCategoryConvInfoService
   * @param {UpdateCategoryConvInfoService} updateCategoryConvInfoService
   * @param {DeleteCategoryConvInfoService} deleteCategoryConvInfoService
   * @memberof KYMW6801Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getCategoryConvInfoService: GetCategoryConvInfoService,
    private registCategoryConvInfoService: RegistCategoryConvInfoService,
    private updateCategoryConvInfoService: UpdateCategoryConvInfoService,
    private deleteCategoryConvInfoService: DeleteCategoryConvInfoService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW6801Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW6801';
    this.kymw6801Model.kymw6801Component = this;
  }

  public ngAfterViewInit() {
    // 画面情報の初期化
    this.initKYMW6801();
    this.eventListenerSetting();
    this.changeDetectorRef.detectChanges();
  }

  public eventListenerSetting(): void {
    // 編集済みチェック用のイベントを割り当て
    const changeObj: Array<any> = [
      // 対象から "商品マスタ" を外すためコメントアウト
      //'rdb_GoodsCategory',
      'rdb_PlanCategory', 'rdb_StockLimitFlg',
      'cmb_ConvDiv', 'lbl_CategoryCode',
      'cmb_ClassCode', 'cmb_LargeClassCode', 'cmb_MiddleClassCode',
      'cmb_SmallClassCode',
      'txti_MarkCode1', 'txti_MarkCode2', 'txti_MarkCode3',
      'cmb_PricePattern', 'cmb_MediumType', 'cmb_FeatureCode',
      'txti_PageNum', 'cmb_ProDiv',
      'cmb_ProInfo', 'txti_ExhibitionDiv',
      'cmb_Tag1', 'cmb_Tag2'
    ];

    for (let i = Number(0); i < changeObj.length; i++) {
      document.getElementById(changeObj[i]).addEventListener('change', () => this.eventEditHandler());
    }
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW6801Component
   */
  public setInterfaceParam(param: any): void {
    this.inputVo = <KYMW6801InputModel>param;
    this.kymw6801Model.procesDiv = this.inputVo.procesDiv;
    /** kymw6800のカテゴリ区分は0:商品マスタ、1:商品企画マスタであるのに対し、
      kymw6801のカテゴリ区分は1:商品マスタ、2:商品企画マスタであるため対応する値を格納*/
    // kymw6800のカテゴリ区分とkymw6801のカテゴリ区分を一致させたため後半をコメントアウト   
    this.kymw6801Model.radioGroup = this.inputVo.categoryDiv; //=== '0' ? '1' : '2';
    this.kymw6801Model.categoryCode = this.inputVo.categoryCode;
  }

  /**
   * カテゴリ変換区分コンボボックス変更イベント
   *
   * @memberof KYMW6801Component
   */
  public eventConvDiv_CHANGEHandler(): void {
    this.clear();
  }

  /**
   * 「プロモーション区分」コンボボックス変更イベント
   *
   * @memberof KYMW6801Component
   */
  public eventProDiv_CHANGEHandler(): void {
    // 再入力後にフォーカスが消えるのを防ぐ為、初期フォーカスのプロパティを設定
    this.cmb_ProDiv.initFocusItem = this.cmb_ConvDiv;

    if ('B' === this.cmb_ProDiv.selectedCodeValue) {                            // バンドルの場合
      // プロモーション情報を非活性
      this.cmb_ProInfo.disabled = true;
      this.cmb_ProInfo.setCodeValue('');
    } else {                                                                    // バンドル以外の場合
      // プロモーション情報を活性
      this.cmb_ProInfo.disabled = false;
    }
  }

  /**
   * 閉じるボタンクリックイベント
   *
   * @memberof KYMW6801Component
   */
  public eventClose_CLICKHandler(): void {
    // 編集が行われている場合、メッセージを表示
    if (this.kymw6801Model.isEdited) {
      this.dialogService.openAlertGetMessage('Q0107', ['カテゴリ変換マスタ情報'],
        (closeDetail) => {
          if (closeDetail === PlessAlert.Yes) {
            this.closeFunction();
          }
        }
      );
    } else {
      // 画面を閉じる
      this.exit();
    }
  }

  /**
   * 「更新」ボタンイベント
   *
   * @returns {void}
   * @memberof KYMW6801Component
   */
  public eventUpdate_CLICKHandler(): void {
    // 編集有無の確認
    if (!this.kymw6801Model.isEdited) {
      this.dialogService.openAlertGetMessage('E0162');
      return;
    }
    // 必須項目のチェック
    const chk: boolean = this.chkParam();

    if (chk) {                                                                  // 必須項目チェックOKの場合

      // 処理区分のチェック
      if (this.kymw6801Model.procesDiv === KYMW6800commonModel.PROCES_DIV_REGIST) {         // 登録の場合

        // メッセージを表示
        this.dialogService.openAlertGetMessage('Q0104', ['カテゴリ変換マスタ情報'],
          (closeDetail) => {
            if (closeDetail === PlessAlert.Yes) {
              this.dispatcherRegistEvent();
            }
          }
        );
      } else if (this.kymw6801Model.procesDiv === KYMW6800commonModel.PROCES_DIV_UPDATE) {  // 更新の場合

        // メッセージを表示
        this.dialogService.openAlertGetMessage('Q0105', ['カテゴリ変換マスタ情報'],
          (closeDetail) => {
            if (closeDetail === PlessAlert.Yes) {
              this.dispatcherUpdateEvent();
            }
          }
        );
      }
    }
  }

  /**
   * 登録イベント発行
   *
   * @memberof KYMW6801Component
   */
  public dispatcherRegistEvent(): void {
    // DB更新イベント発行
    const vo: KYMW6800commonModel = this.getKYMW6800commonVO();

    // データ取得
    this.registCategoryConvInfoService.execute(this.kymw6801Model, vo, () => {
      // 画面を閉じる
      this.exit();
    });
  }

  /**
   * 更新イベント発行
   *
   * @memberof KYMW6801Component
   */
  public dispatcherUpdateEvent(): void {
    // DB更新イベント発行
    const vo: KYMW6800commonModel = this.getKYMW6800commonVO();

    // データ取得
    this.updateCategoryConvInfoService.execute(this.kymw6801Model, vo, () => {
      // 画面を閉じる
      this.exit();
    });
  }

  /**
   * 「削除」ボタンイベント
   *
   * @memberof KYMW6801Component
   */
  public eventDelete_CLICKHandler(): void {
    // メッセージを表示
    this.dialogService.openAlertGetMessage('Q0106', ['カテゴリ変換マスタ情報'],
      (closeDetail) => {
        if (closeDetail === PlessAlert.Yes) {
          if ('01' === this.cmb_ConvDiv.selectedConvDiv) {
            // 変換区分が「01：部門×分類」の場合
            this.dialogService.openAlertGetMessage('Q0106', ['部門×分類・カテゴリ変換マスタ情報'],
              (innerCloseDetail) => {
                if (innerCloseDetail === PlessAlert.Yes) {
                  // 削除イベント発行
                  this.dispatcherDeleteEvent();
                }
              }

            );
          } else {
            // 削除イベント発行
            this.dispatcherDeleteEvent();
          }
        }
      }
    );
  }

  /**
   * 削除イベント発行
   *
   * @memberof KYMW6801Component
   */
  public dispatcherDeleteEvent(): void {
    // DB更新イベント発行
    const vo: KYMW6800commonModel = new KYMW6800commonModel();
    vo.categoryConvID = this.kymw6801Model.categoryConvID;
    vo.updateDate = this.kymw6801Model.updateDate;

    // データ取得
    this.deleteCategoryConvInfoService.execute(this.kymw6801Model, vo, () => {
      // 画面を閉じる
      this.exit();
    });
  }

  /**
   * 項目変更時イベント
   *
   * @memberof KYMW6801Component
   */
  public eventEditHandler(): void {
    this.kymw6801Model.isEdited = true;
  }

  /**
   * デフォルトフォーカス設定
   *
   * @memberof KYMW6801Component
   */
  public initFocus(): void {
    if (this.getFuncPermission('KYMW6800') === '2') {
      this.cmb_ConvDiv.setFocus();
    } else {
      this.btn_Close.nativeElement.focus();
    }
  }

  /**
   * 画面情報の初期化
   *
   * @memberof KYMW6801Component
   */
  public initKYMW6801(): void {
    // 対象から "商品マスタ" を外すためコメントアウト
    //this.kymw6801Model.disabledGoodsCategory = false;
    this.kymw6801Model.disabledPlanCategory = false;
    this.kymw6801Model.disabledStockLimitFlg = false;

    // 処理区分
    this.kymw6801Model.procesDiv = this.inputVo.procesDiv;
    // カテゴリ変換ID
    this.kymw6801Model.categoryConvID = this.inputVo.categoryConvID;
    // マーク１
    this.kymw6801Model.markCode1 = '';
    // マーク２
    this.kymw6801Model.markCode2 = '';
    // マーク３
    this.kymw6801Model.markCode3 = '';
    // ページ
    this.kymw6801Model.pageNum = '';
    // 催事
    this.kymw6801Model.exhibitionDiv = '';

    // 処理区分
    if (this.inputVo.procesDiv === KYMW6801InputModel.PROCES_DIV_REGIST) {          // 「0：登録」 の場合
      this.initForRegist();
    } else if (this.inputVo.procesDiv === KYMW6801InputModel.PROCES_DIV_UPDATE) {   // 「1：更新」 の場合
      this.initForUpdate();
    }
  }

  /**
   * 画面情報の初期化
   * 「処理区分:登録」の場合
   *
   * @memberof KYMW6801Component
   */
  public initForRegist(): void {
    // 削除ボタン
    this.plessEnabled(this.btn_Delete, false);
    //  カテゴリ区分
    /** kymw6800のカテゴリ区分は0:商品マスタ、1:商品企画マスタであるのに対し、
      kymw6801のカテゴリ区分は1:商品マスタ、2:商品企画マスタであるため対応する値を格納 */ 
    // kymw6800 のカテゴリ区分とkymw6801のカテゴリ区分を一致させたため後半をコメントアウト
    this.kymw6801Model.radioGroup = this.inputVo.categoryDiv;// === '0' ? '1' : '2';
    //  カテゴリコード
    this.kymw6801Model.categoryCode = this.inputVo.categoryCode;

    // デフォルトフォーカスの設定
    this.initFocus();

    this.kymw6801Model.isEdited = false;
  }

  /**
   * 画面情報の初期化
   * 「処理区分:更新」の場合
   *
   * @memberof KYMW6801Component
   */
  public initForUpdate(): void {
    // 登録商品情報取得処理

    const vo: KYMW6800commonModel = new KYMW6800commonModel();
    vo.categoryConvID = this.inputVo.categoryConvID;

    // データ取得
    this.getCategoryConvInfoService.execute(this.kymw6801Model, vo);
  }

  /**
   * 画面項目の初期化
   *
   * @memberof KYMW6801Component
   */
  public clear(): void {
    this.cmb_ClassCode.setClassCode('');                                        // 部門コード
    this.cmb_LargeClassCode.setLargeClassCode('');                              // 大分類コード
    this.cmb_MiddleClassCode.setMiddleClassCode('');                            // 中分類コード
    this.cmb_SmallClassCode.setSmallClassCode('');                              // 小分類コード
    this.kymw6801Model.markCode1 = '';                                          // マーク１
    this.kymw6801Model.markCode2 = '';                                          // マーク２
    this.kymw6801Model.markCode3 = '';                                          // マーク３
    this.cmb_PricePattern.setCodeValue('');                                     // 価格パターン
    this.cmb_MediumType.setMediumType('');                                      // 媒体区分
    this.cmb_FeatureCode.setFeatureCode('');                                    // 特集
    this.kymw6801Model.pageNum = '';                                            // ページ番号
    this.cmb_ProDiv.setCodeValue('');                                           // プロモーション区分
    this.cmb_ProInfo.setCodeValue('');                                          // プロモーション情報
    this.kymw6801Model.exhibitionDiv = '';                                      // 催事
    this.cmb_Tag1.setTagValue('');                                               // タグ１
    this.cmb_Tag2.setTagValue('');                                               // タグ２

    this.kymw6801Model.classCode = '';                                          // 部門コード
    this.kymw6801Model.largeClassCode = '';                                     // 大分類コード
    this.kymw6801Model.middleClassCode = '';                                    // 中分類コード
    this.kymw6801Model.smallClassCode = '';                                     // 小分類コード
    this.kymw6801Model.mediumType = '';                                         // 媒体区分
    this.kymw6801Model.promotionDiv = '';                                       // プロモーション区分
    this.kymw6801Model.promotionInfo = '';                                      // プロモーション情報
  }

  /**
   * 更新・登録処理パラメータチェック
   *
   * @returns {Boolean}
   * @memberof KYMW6801Component
   */
  public chkParam(): boolean {
    // 共通
    if (PlessViewUtilsSub.isEmpty(this.kymw6801Model.radioGroup)) {
      this.dialogService.openAlertGetMessage('E0110', ['カテゴリ区分']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(this.cmb_ConvDiv.selectedConvDiv)) {
      this.dialogService.openAlertGetMessage('E0110', ['変換区分']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw6801Model.categoryCode)) {
      this.dialogService.openAlertGetMessage('E0110', ['カテゴリコード']);
      return false;
    }

    // 「変換区分」を基に、必須チェックを行う
    // 部門コード
    if (this.cmb_ConvDiv.selectedClassCodeCtrl &&
      PlessViewUtilsSub.isEmpty(this.cmb_ClassCode.selectedClassCode)) {
      this.dialogService.openAlertGetMessage('E0110', ['部門コード']);
      return false;
    }
    // 大分類コード
    if (this.cmb_ConvDiv.selectedLargeClassCodeCtrl &&
      PlessViewUtilsSub.isEmpty(this.cmb_LargeClassCode.selectedLargeClassCode)) {
      this.dialogService.openAlertGetMessage('E0110', ['大分類コード']);
      return false;
    }
    // 中分類コード
    if (this.cmb_ConvDiv.selectedMiddleClassCodeCtrl &&
      PlessViewUtilsSub.isEmpty(this.cmb_MiddleClassCode.selectedMiddleClassCode)) {
      this.dialogService.openAlertGetMessage('E0110', ['中分類コード']);
      return false;
    }
    // 小分類コード
    if (this.cmb_ConvDiv.selectedSmallClassCodeCtrl &&
      PlessViewUtilsSub.isEmpty(this.cmb_SmallClassCode.selectedSmallClassCode)) {
      // 活性状態 かつ 必須でない場合は必須チェックをスルーさせる
      let ignore = false;
      for (let i = 0; i < this.kymw6801Model.ignoreList.smallClassCode.length; i++) {
        if (this.cmb_ConvDiv.selectedConvDiv === this.kymw6801Model.ignoreList.smallClassCode[i]) {
          ignore = true;
        }
      }
      // 無視リストに存在しない場合、未選択として必須チェックエラーを発生させる
      if (!ignore) {
        this.dialogService.openAlertGetMessage('E0110', ['小分類コード']);
        return false;
      }
    }
    // マーク１
    if (this.cmb_ConvDiv.selectedMarkCode1Ctrl) {
      // 必須チェック
      if (PlessViewUtilsSub.isEmpty(this.kymw6801Model.markCode1)) {
        this.dialogService.openAlertGetMessage('E0110', ['マークコード１']);
        return false;
      }
      // 1～999チェック
      if (0 === Number(this.kymw6801Model.markCode1)) {
        this.dialogService.openAlertGetMessage('W0013', ['マークコード１', '1', '999']);
        return false;
      }
    }
    // マーク２
    if (this.cmb_ConvDiv.selectedMarkCode2Ctrl) {
      // 必須チェック
      if (PlessViewUtilsSub.isEmpty(this.kymw6801Model.markCode2)) {
        this.dialogService.openAlertGetMessage('E0110', ['マークコード２']);
        return false;
      }
      // 1～999チェック
      if (0 === Number(this.kymw6801Model.markCode2)) {
        this.dialogService.openAlertGetMessage('W0013', ['マークコード２', '1', '999']);
        return false;
      }
      // 重複チェック
      if (Number(this.kymw6801Model.markCode1) === Number(this.kymw6801Model.markCode2)) {
        this.dialogService.openAlertGetMessage('E0115', ['マークコード']);
        return false;
      }
    }
    // マーク３
    if (this.cmb_ConvDiv.selectedMarkCode3Ctrl) {
      // 必須チェック
      if (PlessViewUtilsSub.isEmpty(this.kymw6801Model.markCode3)) {
        this.dialogService.openAlertGetMessage('E0110', ['マークコード３']);
        return false;
      }
      // 1～999チェック
      if (0 === Number(this.kymw6801Model.markCode3)) {
        this.dialogService.openAlertGetMessage('W0013', ['マークコード３', '1', '999']);
        return false;
      }
      // 重複チェック
      if (Number(this.kymw6801Model.markCode1) === Number(this.kymw6801Model.markCode3) ||
        Number(this.kymw6801Model.markCode2) === Number(this.kymw6801Model.markCode3)) {
        this.dialogService.openAlertGetMessage('E0115', ['マークコード']);
        return false;
      }
    }
    // 価格パターン
    if (this.cmb_ConvDiv.selectedPricePatternCtrl &&
      PlessViewUtilsSub.isEmpty(this.kymw6801Model.pricePattern)) {
      this.dialogService.openAlertGetMessage('E0110', ['価格パターン']);
      return false;
    }
    // 媒体区分
    if (this.cmb_ConvDiv.selectedMediumTypeCtrl &&
      PlessViewUtilsSub.isEmpty(this.kymw6801Model.mediumType)) {
      this.dialogService.openAlertGetMessage('E0110', ['媒体区分']);
      return false;
    }
    // 特集
    if (this.cmb_ConvDiv.selectedFeatureCodeCtrl &&
      PlessViewUtilsSub.isEmpty(this.kymw6801Model.featureCode)) {
      this.dialogService.openAlertGetMessage('E0110', ['特集']);
      return false;
    }
    // ページ番号
    if (this.cmb_ConvDiv.selectedPageNumCtrl &&
      PlessViewUtilsSub.isEmpty(this.kymw6801Model.pageNum)) {
      this.dialogService.openAlertGetMessage('E0110', ['ページ番号']);
      return false;
    }
    // プロモーション区分
    if (this.cmb_ConvDiv.selectedPromotionDivCtrl &&
      PlessViewUtilsSub.isEmpty(this.kymw6801Model.promotionDiv)) {
      this.dialogService.openAlertGetMessage('E0110', ['プロモーション区分']);
      return false;
    }
    // プロモーション情報
    if (this.cmb_ConvDiv.selectedPromotionDivCtrl &&
      'B' !== this.cmb_ProDiv.selectedCodeValue &&
      PlessViewUtilsSub.isEmpty(this.kymw6801Model.promotionInfo)) {
      this.dialogService.openAlertGetMessage('E0110', ['プロモーション情報']);
      return false;
    }
    // 催事
    if (this.cmb_ConvDiv.selectedExhibitionDivCtrl &&
      PlessViewUtilsSub.isEmpty(this.kymw6801Model.exhibitionDiv)) {
      this.dialogService.openAlertGetMessage('E0110', ['催事']);
      return false;
    }
    // タグ１
    if (this.cmb_ConvDiv.selectedTag1Ctrl &&
      PlessViewUtilsSub.isEmpty(this.kymw6801Model.tag1)) {
      this.dialogService.openAlertGetMessage('E0110', ['タグ１']);
      return false;
    }
    // タグ２
    // 必須チェック
    if (this.cmb_ConvDiv.selectedTag2Ctrl &&
      PlessViewUtilsSub.isEmpty(this.kymw6801Model.tag2)) {
      this.dialogService.openAlertGetMessage('E0110', ['タグ２']);
      return false;
    }
    // 重複チェック
    if ((this.cmb_ConvDiv.selectedTag1Ctrl && this.cmb_ConvDiv.selectedTag2Ctrl) &&
      this.kymw6801Model.tag1 === this.kymw6801Model.tag2) {
      this.dialogService.openAlertGetMessage('E0115', ['タグ２']);
      return false;
    }

    // 更新の場合のみ
    if (this.kymw6801Model.procesDiv === KYMW6800commonModel.PROCES_DIV_UPDATE) {
      if (PlessViewUtilsSub.isEmpty(this.kymw6801Model.categoryConvID)) {
        this.dialogService.openAlertGetMessage('E0110', ['カテゴリ変換ID']);
        return false;
      }
    }
    return true;
  }

  /**
   * 更新・登録用のVOセット
   *
   * @returns {KYMW6800commonModel}
   * @memberof KYMW6801Component
   */
  public getKYMW6800commonVO(): KYMW6800commonModel {
    const vo: KYMW6800commonModel = new KYMW6800commonModel();

    // 共通
    // カテゴリ区分
    vo.categoryDiv = this.kymw6801Model.radioGroup;
    // 変換区分
    vo.convDiv = typeof this.kymw6801Model.convDiv === "string" ? this.kymw6801Model.convDiv : null;
    // カテゴリコード
    vo.categoryCode = this.kymw6801Model.categoryCode;
    // カテゴリ変換ID
    vo.categoryConvID = this.kymw6801Model.categoryConvID;
    // 部門コード
    vo.classCode = typeof this.cmb_ClassCode.selectedClassCode === "string" ? this.cmb_ClassCode.selectedClassCode : null;
    // 大分類コード
    vo.largeClassCode = typeof this.cmb_LargeClassCode.selectedLargeClassCode === "string" ? this.cmb_LargeClassCode.selectedLargeClassCode : null;
    // 中分類コード
    vo.middleClassCode = typeof this.cmb_MiddleClassCode.selectedMiddleClassCode === "string" ? this.cmb_MiddleClassCode.selectedMiddleClassCode : null;
    // 小分類コード
    vo.smallClassCode = typeof this.cmb_SmallClassCode.selectedSmallClassCode === "string" ? this.cmb_SmallClassCode.selectedSmallClassCode : null;
    // マーク１
    vo.markCode1 = this.kymw6801Model.markCode1;
    // マーク２
    vo.markCode2 = this.kymw6801Model.markCode2;
    // マーク３
    vo.markCode3 = this.kymw6801Model.markCode3;
    // 価格パターン
    vo.pricePattern = typeof this.cmb_PricePattern.selectedCodeValue === "string" ? this.cmb_PricePattern.selectedCodeValue : null;
    // 媒体区分
    vo.mediumType = typeof this.cmb_MediumType.selectedMediumType === "string" ? this.cmb_MediumType.selectedMediumType : null;
    // 特集
    vo.featureCode = typeof this.cmb_FeatureCode.selectedFeatureCode === "string" ? this.cmb_FeatureCode.selectedFeatureCode : null;
    // ページ番号
    vo.pageNum = this.kymw6801Model.pageNum;
    // プロモーション区分
    vo.promotionDiv = typeof this.cmb_ProDiv.selectedCodeValue === "string" ? this.cmb_ProDiv.selectedCodeValue : null;
    // プロモーション情報
    vo.promotionInfo = typeof this.cmb_ProInfo.selectedCodeValue === "string" ? this.cmb_ProInfo.selectedCodeValue : null;
    // 催事
    vo.exhibitionDiv = this.kymw6801Model.exhibitionDiv;
    // タグ１
    vo.tag1 = typeof this.cmb_Tag1.selectedTagId === "string" ? this.cmb_Tag1.selectedTagId : null;
    // タグ２
    vo.tag2 = typeof this.cmb_Tag2.selectedTagId === "string" ? this.cmb_Tag2.selectedTagId : null;

    // 更新の場合のみ
    if (this.kymw6801Model.procesDiv === KYMW6800commonModel.PROCES_DIV_UPDATE) {
      vo.categoryConvID = this.kymw6801Model.categoryConvID;
      vo.updateDate = this.kymw6801Model.updateDate;
    }
    return vo;
  }

  /**
   * 画面終了
   *
   * @memberof KYMW6801Component
   */
  public exit(): void {
    // 呼び出し元の画面に検索条件を返却する

    const outputVO: KYMW6801OutputModel = new KYMW6801OutputModel();

    outputVO.categoryCode = this.kymw6801Model.categoryCode;
    outputVO.categoryDiv = this.kymw6801Model.radioGroup;

    this.setKYMW6801Parameter(outputVO);
    // 画面を閉じる
    this.kymw6801Model.isEdited = false;
    super.onClickClose();
  }

  /**
   *  特集コードコンボロード完了通知
   *
   * @param {string} code 選択特集コード
   * @memberof KYMW6801Component
   */
  public featureCodeLoadCompleted(code: string): void {
    this.kymw6801Model.featureCode = code;
  }

  /**
   * 媒体(コンボボックス)_変更時に呼び出される
   *
   * @memberof KYMW6801Component
   */
  public eventMediumType_CHANGEHandler(): void {
    const mediumType: string = this.cmb_MediumType.selectedMediumType;
    this.cmb_FeatureCode.setMediumType(mediumType, this.cmb_FeatureCode.selectedFeatureCode, null);
  }

}
